import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Toolbar } from '@mui/material';
import { Question, QuestionActions } from '../../../components/Styled/Misc';
import {
  SaveButton, CloseButton, ExecuteButton, CancelExecuteButton,
} from '../../../components/Styled/Buttons';
import { actions } from './actions';
import RefreshButton from '../../../components/buttons/refresh';

export const docEditorCP = (AdditionalButton = null) => {
  function CP({
    onActionClick, isChanged, isExecuted, data,
  }) {
    return (
      <Paper sx={{ mb: 1 }}>
        <Toolbar sx={{ gap: 1 }}>
          <SaveButton onClick={(e) => onActionClick(e, actions.save)} disabled={!isChanged} />
          <ExecuteButton onClick={(e) => onActionClick(e, actions.execute)} disabled={isExecuted} />
          <CancelExecuteButton onClick={(e) => onActionClick(e, actions.cancel)} disabled={!isExecuted} />
          <RefreshButton onClick={(e) => onActionClick(e, actions.reload)} disabled={isChanged} />
          {AdditionalButton && (
          <AdditionalButton
            onActionClick={onActionClick}
            isChanged={isChanged}
            isExecuted={isExecuted}
            data={data}
          />
          )}
          {isChanged ? (
            <Question
              questionText="Вийти без запису?"
              actionHandler={(e, v) => {
                if (v === QuestionActions.YesNoAction.yes.value) {
                  onActionClick(e, actions.close);
                }
                e.stopPropagation();
              }}
              actions={Object.values(QuestionActions.YesNoAction)}
            >
              <CloseButton onClick={(e) => onActionClick(e, actions.close)} />
            </Question>
          ) : (
            <CloseButton onClick={(e) => onActionClick(e, actions.close)} />
          )}
        </Toolbar>
      </Paper>
    );
  }

  CP.propTypes = {
    onActionClick: PropTypes.func.isRequired,
    isChanged: PropTypes.bool,
    isExecuted: PropTypes.bool,
    data: PropTypes.shape({}),
  };

  CP.defaultProps = {
    isChanged: false,
    isExecuted: false,
    data: {},
  };

  return CP;
};

docEditorCP.propTypes = {
  onActionClick: PropTypes.func.isRequired,
  isChanged: PropTypes.bool,
  isExecuted: PropTypes.bool,
};

docEditorCP.defaultProps = {
  isChanged: false,
  isExecuted: false,
};

export default docEditorCP;
